import { Any, JsonObject, JsonProperty } from 'json2typescript';
import { CollectionTranslation } from './collection-translation.model';
import { CollectionReward } from './collection-reward.model';

@JsonObject('CollectionAlbum')
export class CollectionAlbum {

  @JsonProperty('album_id', Number)
  albumId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('cards_count', Number)
  cardsCount: number = 0;

  @JsonProperty('image_updated_at', Any)
  imageUpdatedAt: number | null = null;

  @JsonProperty('translations', [CollectionTranslation])
  translations: CollectionTranslation[] = [];

  @JsonProperty('rewards', [CollectionReward])
  rewards: CollectionReward[] = [];
}
